const NOT_APPLICABLE = 'n/a';
const UNLIMITED = 'unlimited';
const UNIDENTIFIED = 'Unidentified';

export {
    NOT_APPLICABLE,
    UNLIMITED,
    UNIDENTIFIED
};
